import { TemplateRef, ViewChild, EventEmitter, Output, OnDestroy, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DxButtonModule, DxDataGridModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbstractControl, FormsModule, NgForm, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { errorMessages, modalButtonTitles, ModalConfig, modalHeading, toastMessage } from '@app/shared/constants/modal.model';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DataGridInputs, DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { AlertService } from '@core/services/alert.service';
import { take, takeUntil } from 'rxjs';
import { Subject } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import {
  ApplicationFee,
  ApplicationRule,
  BackgroundCheck,
  ExamRequirement,
  GenericRule,
  LicenseDuration
} from '../../shared/interfaces/business-rules.interfaces';
import { EditdatagridComponent } from '@app/shared/custom-component/editdatagrid/editdatagrid.component';
import { DateMaskDirective } from '@app/shared/directives/dateMask.directive';
import { businessFields } from '@app/shared/constants/business-rules.constants';
import { patternMatch } from '@app/shared/constants/validators.model';
import { SystemConfigurationService } from '../system-configuration.service';
import { CommonService } from '@app/shared/services/common.service';

@Component({
  selector: 'app-business-rules',
  templateUrl: './business-rules.component.html',
  styleUrls: ['./business-rules.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DataGridComponent,
    DxDataGridModule,
    DxPopupModule,
    DxTemplateModule,
    DxButtonModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    EditorModule,
    InputMaskModule,
    InputTextModule,
    RadioButtonModule,
    DropdownModule,
    DialogModule, EditdatagridComponent, DateMaskDirective
  ]
})
export class BusinessRulesComponent implements OnInit, OnDestroy {
  @Output() rowChanged = new EventEmitter<any>();
  selectedExam: any = null;
  editRowKey: any = null;
  originalRowValues: { [key: string]: any } = {};
  toastMessage: any = {};
  errorMessage: any = {};
  showEditFeesModal: boolean = false;
  showEditExamModal: boolean = false;
  examStatus: string = 'Active';
  showDeactivateExamModal: boolean = false;
  showActivateExamModal: boolean = false;
  applicationForm: FormGroup;
  applicationFeesForm: FormGroup;
  backgroundForm: FormGroup;
  examRequirementsForm: FormGroup;
  licenseDurationForm: FormGroup;
  queueManagementForm: FormGroup;
  registrationForm: FormGroup;
  securityForm: FormGroup;
  caseForm: FormGroup;
  documentForm: FormGroup;
  licensingForm: FormGroup;
  dataGridConfigApplication: DataGridVO = DataGridVO.create({});
  dataGridConfigCase: DataGridVO = DataGridVO.create({});
  dataGridConfigDocument: DataGridVO = DataGridVO.create({});
  dataGridConfigLicensing: DataGridVO = DataGridVO.create({});
  dataGridConfigQueues: DataGridVO = DataGridVO.create({});
  dataGridConfigFees: DataGridVO = DataGridVO.create({});
  dataGridConfigBackground: DataGridVO = DataGridVO.create({});
  dataGridConfigEmployee: DataGridVO = DataGridVO.create({});
  dataGridConfigLicense: DataGridVO = DataGridVO.create({});
  dataGridConfigSecurity: DataGridVO = DataGridVO.create({});
  dataGridConfigRegistration: DataGridVO = DataGridVO.create({});
  Application: boolean = false;
  Case: boolean = false;
  Documents: boolean = false;
  Licensing: boolean = false;
  ApplicationFees: boolean = false;
  Background: boolean = false;
  ExamRequirements: boolean = false;
  LicenseDuration: boolean = false;
  QueueManagement: boolean = false;
  Registration: boolean = false;
  Security: boolean = false;
  applicationRows: ApplicationRule[] = [];
  caseRows: any[] = [];
  documentRows: any[] = [];
  licensingRows: any[] = [];
  feeRows: ApplicationFee[] = [];
  licenseRows: LicenseDuration[] = [];
  jurisdiction = [];
  applicationHeaders: any[] = [];
  caseHeaders: any[] = [];
  documentHeaders: any[] = [];
  licensingHeaders: any[] = [];
  feeHeaders: any[] = [];
  licenseHeaders: any[] = [];
  jurisdictionHeaders: any[] = [];
  backgroundHeaders: any[] = [];
  examHeaders: any[] = [];
  queueHeaders: any[] = [];
  registrationHeaders: any[] = [];
  securityHeaders: any[] = [];
  backgroundRows: BackgroundCheck[] = [];
  examRows: ExamRequirement[] = [];
  queueRows: GenericRule[] = [];
  securityRows: GenericRule[] = [];
  registrationRows: GenericRule[] = [];
  educationRows: any[] = [];
  @ViewChild('employeeGrid') employeeGrid?: DataGridComponent;
  private destroy$ = new Subject<void>();
  applicationApiPayload: ApplicationRule | undefined;
  queueManagementApiPayload: GenericRule | undefined;
  registrationApiPayload: GenericRule | undefined;
  securityApiPayload: GenericRule | undefined;
  isExamActive: boolean = false;
  examTestType: string = 'Test_Type';
  customModal: any;
  @ViewChild('editExamModal', { static: false }) editExamModal!: TemplateRef<any>;
  @ViewChild('startDateTextInput') startDateTextInput?: ElementRef<HTMLInputElement>;
  @ViewChild('endDateTextInput') endDateTextInput?: ElementRef<HTMLInputElement>;
  @ViewChild('startHiddenDateInput') startHiddenDateInput?: ElementRef<HTMLInputElement>;
  @ViewChild('endHiddenDateInput') endHiddenDateInput?: ElementRef<HTMLInputElement>;
  private dtEffEndDateDestroy$ = new Subject<void>();
  effEndDateToolTip: any;
  showModalEffEndDateTooltip: boolean = false;
  examExists = false;
  modalExamData: any = {};
  modalExamNameExists = false;
  modalPattern = {
      examCdPattern: patternMatch.examCode.source,
      examNamePattern: patternMatch.examName.source,
      passScorePattern: patternMatch.passCode.source
  }
  constructor(
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    private alertService: AlertService,
    private ngbService: NgbModal,
    private systemConfigurationService: SystemConfigurationService,
  ) {
    // dependencies injected for HTTP and change detection
      console.log('modalPattern', this.modalPattern);
  }

  private flattenCategoryData(it: any) {
    const cd = it?.category_data || it?.objCategoryData || {};
    const sources = [cd, it];
    return {
      intBusinessRuleId: it.intBusinessRuleId,
      category: it.objCategoryData,
      rule_name: this.pickFirstField(sources, ['strRuleName', 'rule_name']),
      description: this.pickFirstField(sources, ['strDescription', 'description']),
      value: this.pickFirstField(sources, ['intValue', 'value']),
      unit: this.pickFirstField(sources, ['strUnit', 'unit']),
      applies_to: this.pickFirstField(sources, ['strAppliesTo', 'applies_to']),
      updated_by: this.pickFirstField(sources, ['strLastModifiedByFullName', 'updated_by']),
      date_updated: this.pickFirstField(sources, [
        'dtUpdatedDate',
        'Date_Updated',
        'dateUpdated',
        'date_updated',
        'modified_date'
      ]),
      categoryData: cd,
      ...it
    };
  }

  private pickFirstField(sources: any[], candidates: string[]) {
    for (const src of sources) {
      if (!src) continue;
      for (const c of candidates) {
        if (src[c] !== undefined && src[c] !== null) return src[c];
      }
    }
    return '';
  }

  private makeGridConfig(headers: any[], data: any[], overrides: Partial<DataGridInputs> = {}) {
    // Always map Value for each row before passing to DataGridVO
    const mappedData = Array.isArray(data)
      ? data.map(row => {
        const copy: any = { ...row };
        if (copy.Value === undefined) {
          if (copy.intValue !== undefined) {
            copy.Value = copy.intValue;
          } else if (copy.value !== undefined) {
            copy.Value = copy.value;
          }
        }
        return copy;
      })
      : data;
    return DataGridVO.create({
      customHeaders: headers,
      data: mappedData,
      showActionsColumn: true,
      showFiltering: true,
      showSearchRow: true,
      showPaging: false,
      customNoDataText: 'No data',
      ...overrides
    });
  }

  ngOnInit() {
    this.applicationForm = new FormGroup({
      applicationNumber: new FormControl(''),
      ruleName: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      unit: new FormControl(''),
      appliesTo: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    // Initialize originalRowValues when data loads

    this.applicationFeesForm = new FormGroup({
      feeScheduleName: new FormControl('', { validators: [Validators.required] }),
      feeComponent: new FormControl('', { validators: [Validators.required] }),
      feeAmount: new FormControl('', { validators: [Validators.required], nonNullable: true }),
      dtEffStartDate: new FormControl('', { validators: [Validators.required] }),
      dtEffEndDate: new FormControl('')
    });
    this.backgroundForm = new FormGroup({
      applicationNumber: new FormControl(''),
      backgroundType: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    this.examRequirementsForm = new FormGroup({
      strExamCd: new FormControl('', {
        validators: [
          Validators.required,
          Validators.pattern(patternMatch.examCode)
        ]
      }),
      strExamName: new FormControl('', {
        validators: [
          Validators.required,
          Validators.pattern(patternMatch.examName)
        ]
      }),
      strPassCd: new FormControl('', {
        validators: [
          Validators.required,
          Validators.pattern(patternMatch.passCode)
        ]
      }),
      dtEffStartDate: new FormControl('', { validators: [Validators.required, this.strictDateValidator()] }),
      dtEffEndDate: new FormControl('', { validators: [this.strictDateValidator()] })
    });
    this.licenseDurationForm = new FormGroup({
      licenseType: new FormControl(''),
      duration: new FormControl(''),
      unit: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    this.queueManagementForm = new FormGroup({
      queueName: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    this.registrationForm = new FormGroup({
      registrationNumber: new FormControl(''),
      ruleName: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    this.securityForm = new FormGroup({
      securityType: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    this.caseForm = new FormGroup({
      caseNumber: new FormControl(''),
      ruleName: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      unit: new FormControl(''),
      appliesTo: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    this.documentForm = new FormGroup({
      documentType: new FormControl(''),
      ruleName: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    this.licensingForm = new FormGroup({
      licenseType: new FormControl(''),
      ruleName: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      updatedBy: new FormControl(''),
      dateUpdated: new FormControl('')
    });
    // Initialize tooltip for Effective End Date
    this.effEndDateToolTip = toastMessage.G0036;
    this.loadErrorMessages();
    this.fetchBusinessRulesData();
  }

  onCellValueChanged(e: any) {
    if (e.column && e.column.dataField === 'Value') {
      if (e.oldValue !== e.value) {
        this.rowChanged.emit(e.data);
      }
    }
  }

  loadErrorMessages() {
    this.systemConfigurationService.getErrorMessages().pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (resp: any) => {
        const messages = resp?.data || resp || [];
        messages.forEach((message: any) => {
          if (message.key && message.value !== undefined) {
            this.errorMessage[message.key] = message.value;
          }
        });
      }
    });
    this.systemConfigurationService.getToastMessages().pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (resp: any) => {
        const messages = resp?.data || resp || [];
        messages.forEach((message: any) => {
          if (message.key && message.value !== undefined) {
            this.toastMessage[message.key] = message.value;
          }
        });
      }
    });
  }

  fetchBusinessRulesData() {
    const normalizeBusinessRulesData = (payload: any): any[] => {
      const root = payload?.data?.data ?? payload?.data ?? payload;

      if (Array.isArray(root)) {
        return root;
      }

      if (!root || typeof root !== 'object') {
        return [];
      }

      const categoryKeyMap: { [key: string]: string } = {
        recordsApplication: 'Application',
        recordsCase: 'Case',
        recordsDocuments: 'Documents',
        recordsLicensing: 'Licensing',
        recordsQueueManagement: 'Queue Management',
        recordsRegistration: 'Registration',
        recordsSecurity: 'Security',
        recordsLicense: 'License',
        recordsApplicationFees: 'Application Fees',
        recordsBackground: 'Background',
        recordsExamRequirements: 'Exam Requirements'
      };

      const groupedRows = Object.keys(categoryKeyMap).flatMap(key => {
        const rows = root[key];
        if (!Array.isArray(rows)) {
          return [];
        }
        const category = categoryKeyMap[key];
        return rows.map((row: any) => ({
          ...row,
          strCategory: row?.strCategory || category
        }));
      });

      if (groupedRows.length) {
        return groupedRows;
      }

      const fallbackArray =
        (Array.isArray(root.items) && root.items) ||
        (Array.isArray(root.rows) && root.rows) ||
        (Array.isArray(root.records) && root.records) ||
        [];

      if (fallbackArray.length) {
        return fallbackArray;
      }

      const looksLikeSingleRule =
        root.intBusinessRuleId !== undefined ||
        root.objCategoryData !== undefined ||
        root.category_data !== undefined ||
        root.strCategory !== undefined;

      return looksLikeSingleRule ? [root] : [];
    };

    const setHeaders = (src: any) => {
      this.applicationHeaders = src.applicationHeaders || [];
      // Case, Documents, and Licensing use same columns as Application
      this.caseHeaders = this.applicationHeaders;
      this.documentHeaders = this.applicationHeaders;
      this.licensingHeaders = this.applicationHeaders;
      this.feeHeaders = src.ApplicationFees || [];
      this.licenseHeaders = src.licenseHeaders || [];
      this.jurisdictionHeaders = src.jurisdictionHeaders || [];
      this.backgroundHeaders = src.backgroundHeaders || [];
      this.examHeaders = src.examHeaders || [];
      this.queueHeaders = this.applicationHeaders;
      this.registrationHeaders = this.applicationHeaders;
      this.securityHeaders = this.applicationHeaders;
    };
    const setEmptyRows = () => {
      this.applicationRows = [];
      this.caseRows = [];
      this.documentRows = [];
      this.licensingRows = [];
      this.queueRows = [];
      this.registrationRows = [];
      this.securityRows = [];
      this.licenseRows = [];
      this.feeRows = [];
      this.backgroundRows = [];
      this.examRows = [];
    };
    const setEmptyConfigs = () => {
      const configs: [() => any, (v: any) => void][] = [
        [() => this.applicationHeaders, (v) => { this.dataGridConfigApplication = this.makeGridConfig(v, [], { showQueueActions: true, disableApplicationClick: false }); }],
        [() => this.caseHeaders, (v) => { this.dataGridConfigCase = this.makeGridConfig(v, [], { showQueueActions: true, disableApplicationClick: false }); }],
        [() => this.documentHeaders, (v) => { this.dataGridConfigDocument = this.makeGridConfig(v, [], { showQueueActions: true, disableApplicationClick: false }); }],
        [() => this.licensingHeaders, (v) => { this.dataGridConfigLicensing = this.makeGridConfig(v, [], { showQueueActions: true, disableApplicationClick: false }); }],
        [() => this.examHeaders, (v) => { this.dataGridConfigEmployee = this.makeGridConfig(v, [], { showQueueActions: true, disableApplicationClick: false }); }],
        [() => this.feeHeaders, (v) => { this.dataGridConfigFees = this.makeGridConfig(v, [], { showQueueActions: false, disableApplicationClick: true }); }],
        [() => this.backgroundHeaders, (v) => { this.dataGridConfigBackground = this.makeGridConfig(v, [], { showQueueActions: false, disableApplicationClick: true }); }],
        [() => this.licenseHeaders, (v) => { this.dataGridConfigLicense = this.makeGridConfig(v, [], { showQueueActions: false, disableApplicationClick: true }); }],
        [() => this.queueHeaders, (v) => { this.dataGridConfigQueues = this.makeGridConfig(v, [], { showQueueActions: false, disableApplicationClick: true }); }],
        [() => this.securityHeaders, (v) => { this.dataGridConfigSecurity = this.makeGridConfig(v, [], { showQueueActions: false, disableApplicationClick: true }); }],
        [() => this.registrationHeaders, (v) => { this.dataGridConfigRegistration = this.makeGridConfig(v, [], { showQueueActions: false, disableApplicationClick: true }); }],
      ];
      for (const [getH, setC] of configs) {
        setC(getH());
      }
    };
    const setAllEmpty = () => { setEmptyRows(); setEmptyConfigs(); };
    const setAllFromHeaders = (src: any) => { setHeaders(src); setAllEmpty(); };
    const setAllFromHeadersAndData = (headersJson: any, data: any) => {
      setHeaders(headersJson);
      const safeData = normalizeBusinessRulesData(data);
      const flattened = safeData.map((it: any) => this.flattenCategoryData(it));
      const ensureValueProp = (row: any) => {
        const normalizedValue =
          row.value !== undefined && row.value !== null
            ? row.value
            : row.Value !== undefined && row.Value !== null
              ? row.Value
              : row.intValue !== undefined && row.intValue !== null
                ? row.intValue
                : '';
        if (row.strCategory === 'Exam Requirements' && row.objCategoryData) {
          return {
            ...row,
            strExamCd: row.objCategoryData.strExamCd || row.strExamCd || '',
            strExamName: row.objCategoryData.strExamName || row.strExamName || '',
            strPassCd: row.objCategoryData.strPassCd || row.strPassCd || '',
            strTestType: row.objCategoryData.strTestType || row.strTestType || '',
            dtEffStartDate: row.objCategoryData.dtEffStartDate || row.dtEffStartDate || '',
            dtEffEndDate: row.objCategoryData.dtEffEndDate || row.dtEffEndDate || '',
            value: normalizedValue,
            Value: normalizedValue,
            intValue: normalizedValue,
            objCategoryData: {
              ...(row.objCategoryData || {}),
              intValue: normalizedValue
            },
            State: (row.objCategoryData?.blIsActivated || row.blIsActivated) ? modalButtonTitles.active : modalButtonTitles.inactive
          };
        }
        return {
          ...row,
          value: normalizedValue,
          Value: normalizedValue,
          intValue: normalizedValue,
          objCategoryData: {
            ...(row.objCategoryData || {}),
            intValue: normalizedValue
          }
        };
      };
      const mapRowsFor = (rows: any[], headers: any[], category?: string) => rows.map(row => {
        const normalizedRow = ensureValueProp(row);
        const out: any = { ...normalizedRow };
        const norm = (s: string) => s.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normMap: any = {};
        Object.keys(normalizedRow).forEach(k => { normMap[norm(k)] = normalizedRow[k]; });
        headers.forEach(header => {
          const df = header.dataField;
          if (['Queue Management', 'Security', 'Registration'].includes(category || '') && df === 'Date_Updated') {
            const getDateUpdatedValue = (row: any) => {
              const norm = (s: string) => s.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
              let dateVal = '';
              if (row.categoryData) {
                for (const k of Object.keys(row.categoryData)) {
                  const nk = norm(k);
                  if (nk === 'dtupdateddate') { dateVal = row.categoryData[k]; break; }
                }
              }
              return (
                dateVal || row.categoryData?.dtUpdatedDate || row.categoryData?.dtUpdateddate || row.categoryData?.Date_Updated || row.categoryData?.dateUpdated || row.date_updated || row.strLastModifiedByFullName || row.Date_Updated || row.dtUpdatedDate || row.dateUpdated || ''
              );
            };
            out[df] = getDateUpdatedValue(normalizedRow) || normMap[norm(df)] || normalizedRow[df] || '';
          } else {
            out[df] = normMap[norm(df)] ?? normalizedRow[df] ?? '';
          }
        });
        return out;
      });
      // Sort helper function to maintain alphabetical order by Rule Name
      const sortByRuleName = (rows: any[]) => {
        return rows.sort((a, b) => {
          const nameA = (a.rule_name || a.rulename || a.strRuleName || a['Rule Name'] || '').toString().toLowerCase();
          const nameB = (b.rule_name || b.rulename || b.strRuleName || b['Rule Name'] || '').toString().toLowerCase();
          return nameA.localeCompare(nameB);
        });
      };

      this.applicationRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Application'), this.applicationHeaders, 'Application'));
      this.initOriginalRowValues();
      this.caseRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Case'), this.caseHeaders, 'Case'));
      this.documentRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Documents'), this.documentHeaders, 'Documents'));
      this.licensingRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Licensing'), this.licensingHeaders, 'Licensing'));
      this.queueRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Queue Management'), this.queueHeaders, 'Queue Management'));
      this.registrationRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Registration'), this.registrationHeaders, 'Registration'));
      this.securityRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Security'), this.securityHeaders, 'Security'));
      this.licenseRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'License'), this.licenseHeaders, 'License'));
      this.feeRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Application Fees'), this.feeHeaders, 'Application Fees'));
      this.backgroundRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === 'Background'), this.backgroundHeaders, 'Background'));
      this.examRows = sortByRuleName(mapRowsFor(flattened.filter((x: any) => x.strCategory === "Exam Requirements"), this.examHeaders, 'Exam Requirements'));
      this.dataGridConfigApplication = this.makeGridConfig(
        this.applicationHeaders,
        this.applicationRows,
        {
          showQueueActions: true,
          disableApplicationClick: false,
          showPaging: this.applicationRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigApplication = DataGridVO.create({ ...this.dataGridConfigApplication });
      this.dataGridConfigEmployee = this.makeGridConfig(
        this.examHeaders,
        this.examRows,
        {
          showQueueActions: true,
          disableApplicationClick: false,
          showPaging: this.examRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigEmployee = DataGridVO.create({ ...this.dataGridConfigEmployee });
      this.dataGridConfigFees = this.makeGridConfig(
        this.feeHeaders,
        this.feeRows,
        {
          showQueueActions: false,
          disableApplicationClick: true,
          showPaging: this.feeRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigFees = DataGridVO.create({ ...this.dataGridConfigFees });
      this.dataGridConfigBackground = this.makeGridConfig(
        this.backgroundHeaders,
        this.backgroundRows,
        {
          showQueueActions: false,
          disableApplicationClick: true,
          showPaging: this.backgroundRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigBackground = DataGridVO.create({ ...this.dataGridConfigBackground });
      this.dataGridConfigLicense = this.makeGridConfig(
        this.licenseHeaders,
        this.licenseRows,
        {
          showQueueActions: false,
          disableApplicationClick: true,
          showPaging: this.licenseRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigLicense = DataGridVO.create({ ...this.dataGridConfigLicense });
      this.dataGridConfigQueues = this.makeGridConfig(
        this.queueHeaders,
        this.queueRows,
        {
          showQueueActions: false,
          disableApplicationClick: true,
          showPaging: this.queueRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigQueues = DataGridVO.create({ ...this.dataGridConfigQueues });
      this.dataGridConfigRegistration = this.makeGridConfig(
        this.registrationHeaders,
        this.registrationRows,
        {
          showQueueActions: false,
          disableApplicationClick: true,
          showPaging: this.registrationRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigRegistration = DataGridVO.create({ ...this.dataGridConfigRegistration });
      this.dataGridConfigSecurity = this.makeGridConfig(
        this.securityHeaders,
        this.securityRows,
        {
          showQueueActions: false,
          disableApplicationClick: true,
          showPaging: this.securityRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigSecurity = DataGridVO.create({ ...this.dataGridConfigSecurity });
      this.dataGridConfigCase = this.makeGridConfig(
        this.caseHeaders,
        this.caseRows,
        {
          showQueueActions: true,
          disableApplicationClick: false,
          showPaging: this.caseRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigCase = DataGridVO.create({ ...this.dataGridConfigCase });
      this.dataGridConfigDocument = this.makeGridConfig(
        this.documentHeaders,
        this.documentRows,
        {
          showQueueActions: true,
          disableApplicationClick: false,
          showPaging: this.documentRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigDocument = DataGridVO.create({ ...this.dataGridConfigDocument });
      this.dataGridConfigLicensing = this.makeGridConfig(
        this.licensingHeaders,
        this.licensingRows,
        {
          showQueueActions: true,
          disableApplicationClick: false,
          showPaging: this.licensingRows.length >= 5 ? true : false,
          customPageSize: 5,
          customPageSizes: [5,10, 20, 50]
        }
      );
      this.dataGridConfigLicensing = DataGridVO.create({ ...this.dataGridConfigLicensing });
      this.setGridPagerClass();
    };

    this.http.get<any>(API_ENDPOINTS.BUSINESS_RULES_HEADERS).subscribe({
      next: headersJson => {
        this.systemConfigurationService.fetchBusinessRules().pipe(take(1), takeUntil(this.destroy$)).subscribe({
          next: (resp: { data?: any } | any) => {
            const items = normalizeBusinessRulesData(resp);
            setAllFromHeadersAndData(headersJson, items);
          },
          error: () => {
            this.http.get<any>('assets/metadata/business-rules-headers.json').subscribe({
              next: localHeaders => { setAllFromHeaders(localHeaders); },
              error: setAllEmpty
            });
          }
        });
      },
      error: () => {
        this.http.get<any>('assets/metadata/business-rules-headers.json').subscribe({
          next: localHeaders => { setAllFromHeaders(localHeaders); },
          error: setAllEmpty
        });
      }
    });
  }
  initOriginalRowValues() {
    this.originalRowValues = {};
    // Application
    for (const row of this.applicationRows) {
      const key = row.strRuleName;
      this.originalRowValues[key] = {
        intValue: row.intValue,
        strUnit: row.strUnit,
        strAppliesTo: row.strAppliesTo
      };
    }
    // Queue Management
    for (const row of this.queueRows) {
      const key = row.strRuleName;
      this.originalRowValues[key] = {
        intValue: row.intValue
      };
    }
    // Registration
    for (const row of this.registrationRows) {
      const key = row.strRuleName;
      this.originalRowValues[key] = {
        intValue: row.intValue
      };
    }
    // Security
    for (const row of this.securityRows) {
      const key = row.strRuleName;
      this.originalRowValues[key] = {
        intValue: row.intValue
      };
    }
    // License Duration
    for (const row of this.licenseRows) {
      const key = row.strLicenseType;
      this.originalRowValues[key] = {
        intLicDuration: row.intLicDuration,
        strExpDateRule: row.strExpDateRule
      };
    }
    // Application Fees
    for (const row of this.feeRows) {
      const key = row.strFeeSchedNm;
      this.originalRowValues[key] = {
        strFeeAmt: row.strFeeAmt,
        strFeeComp: row.strFeeComp
      };
    }
    // Background
    for (const row of this.backgroundRows) {
      const key = row.strAppPath;
      this.originalRowValues[key] = {
        intBgCheckReq: row.intBgCheckReq
      };
    }
    // Exam Requirements
    for (const row of this.examRows) {
      const key = row.strExamCd;
      this.originalRowValues[key] = {
        strPassCd: row.strPassCd,
        strExamName: row.strExamName
      };
    }
    // Case
    for (const row of this.caseRows) {
      const key = row.strRuleName;
      this.originalRowValues[key] = {
        intValue: row.intValue,
        strUnit: row.strUnit,
        strAppliesTo: row.strAppliesTo
      };
    }
    // Documents
    for (const row of this.documentRows) {
      const key = row.strRuleName;
      this.originalRowValues[key] = {
        intValue: row.intValue
      };
    }
    // Licensing
    for (const row of this.licensingRows) {
      const key = row.strRuleName;
      this.originalRowValues[key] = {
        intValue: row.intValue
      };
    }
  }
  toggleSection(section: string) {
    switch (section) {
      case 'Application':
        this.Application = !this.Application;
        this.dataGridConfigApplication = DataGridVO.create({ ...this.dataGridConfigApplication });
        break;
      case 'ApplicationFees':
        this.ApplicationFees = !this.ApplicationFees;
        this.dataGridConfigFees = DataGridVO.create({ ...this.dataGridConfigFees });
        break;
      case 'Background':
        this.Background = !this.Background;
        this.dataGridConfigBackground = DataGridVO.create({ ...this.dataGridConfigBackground });
        break;
      case 'ExamRequirements':
        this.ExamRequirements = !this.ExamRequirements;
        this.dataGridConfigEmployee = DataGridVO.create({ ...this.dataGridConfigEmployee });
        break;
      case 'LicenseDuration':
        this.LicenseDuration = !this.LicenseDuration;
        this.dataGridConfigLicense = DataGridVO.create({ ...this.dataGridConfigLicense });
        break;
      case 'QueueManagement':
        this.QueueManagement = !this.QueueManagement;
        this.dataGridConfigQueues = DataGridVO.create({ ...this.dataGridConfigQueues });
        break;
      case 'Registration':
        this.Registration = !this.Registration;
        this.dataGridConfigRegistration = DataGridVO.create({ ...this.dataGridConfigRegistration });
        break;
      case 'Security':
        this.Security = !this.Security;
        this.dataGridConfigSecurity = DataGridVO.create({ ...this.dataGridConfigSecurity });
        break;
      case 'Case':
        this.Case = !this.Case;
        this.dataGridConfigCase = DataGridVO.create({ ...this.dataGridConfigCase });
        break;
      case 'Documents':
        this.Documents = !this.Documents;
        this.dataGridConfigDocument = DataGridVO.create({ ...this.dataGridConfigDocument });
        break;
      case 'Licensing':
        this.Licensing = !this.Licensing;
        this.dataGridConfigLicensing = DataGridVO.create({ ...this.dataGridConfigLicensing });
        break;
      default:
        break;
    }
    if (this.cd && typeof this.cd.detectChanges === 'function') {
      this.cd.detectChanges();
    }
  }

  onRefresh(row: any) {
    console.log('Refresh clicked for row:', row);
  }

  onLock(row: any) {
    console.log('Lock clicked for row:', row);
  }

  onEditEmployee(cell: any) {
    console.log('Edit clicked for', cell.data);
  }
  onToggleEmployeeClick(cell: any) {
    const row = cell && (cell.data !== undefined ? cell.data : cell);
    if (!row) return;

    row.__employeeEnabled = !row.__employeeEnabled;
    const idx = this.educationRows.findIndex(r => r === row || r.Exam_Code === row.Exam_Code);
    if (idx >= 0) {
      const newRow = { ...this.educationRows[idx], __employeeEnabled: row.__employeeEnabled };
      const newArr = [...this.educationRows];
      newArr[idx] = newRow;
      this.educationRows = newArr;
      try {
        this.dataGridConfigEmployee = this.dataGridConfigEmployee.updateConfig({ data: this.educationRows });
      } catch (e) {
        console.warn('Failed to update DataGridVO config', e);
      }
    } else {
      try {
        this.dataGridConfigEmployee = this.dataGridConfigEmployee.updateConfig({ data: this.educationRows });
      } catch (e) {
        console.warn('Failed to update DataGridVO config', e);
      }
    }
    this.cd.detectChanges();

    if (this.employeeGrid && typeof (this.employeeGrid as any).updateConfiguration === 'function') {
      try {
        (this.employeeGrid as any).updateConfiguration({ data: this.educationRows });
      } catch (e) {
        console.warn('employeeGrid.updateConfiguration failed', e);
      }
    }
  }


  onApplicationRowChanged(updatedRow: any) {
    // Only update the value in-place to avoid grid refresh and focus loss
    const idx = this.applicationRows.findIndex(r => r.strRuleName === updatedRow.strRuleName);
    if (idx > -1) {
      this.applicationRows[idx].intValue = updatedRow.Value || updatedRow.intValue;
    }
    // Do not patch the form or trigger change detection here to preserve focus
    // Only set editRowKey for save button
    this.editRowKey = updatedRow.strRuleName;
    // No need to update originalRowValues here; only after save
  }
  onCaseRowChanged(updatedRow: any) {
    // Only update the value in-place to avoid grid refresh and focus loss
    const idx = this.caseRows.findIndex(r => r.strRuleName === updatedRow.strRuleName);
    if (idx > -1) {
      this.caseRows[idx].intValue = updatedRow.Value || updatedRow.intValue;
    }
    // Do not patch the form or trigger change detection here to preserve focus
    // Only set editRowKey for save button
    this.editRowKey = updatedRow.strRuleName;
    // No need to update originalRowValues here; only after save
  }
  onApplicationFeesRowChanged(updatedRow: any) {
    const idx = this.feeRows.findIndex(r => r.strFeeSchedNm === updatedRow.strFeeSchedNm);
    if (idx > -1) {
      this.feeRows[idx] = { ...updatedRow };
    } else {
      this.feeRows.push(updatedRow);
    }
    this.applicationFeesForm.patchValue({
      strFeeSchedNm: updatedRow.strFeeSchedNm,
      strFeeComp: updatedRow.strFeeComp,
      strFeeAmt: updatedRow.strFeeAmt,
      dtEffStartDate: updatedRow.dtEffStartDate,
      dtEffEndDate: updatedRow.dtEffEndDate,
      strStatus: updatedRow.strStatus
    });
    this.applicationFeesForm.markAsDirty();
  }
  onBackgroundRowChanged(updatedRow: any) {
    const idx = this.backgroundRows.findIndex(r => r.strAppPath === updatedRow.strAppPath);
    if (idx > -1) {
      this.backgroundRows[idx] = { ...updatedRow };
    } else {
      this.backgroundRows.push(updatedRow);
    }
    this.backgroundForm.patchValue({
      strAppPath: updatedRow.strAppPath,
      strAppType: updatedRow.strAppType,
      intBgCheckReq: updatedRow.intBgCheckReq
    });
  }
  onExamRequirementsRowChanged(updatedRow: any) {
    const idx = this.examRows.findIndex(r => r.strExamCd === updatedRow.strExamCd);
    if (idx > -1) {
      this.examRows[idx] = { ...this.examRows[idx], ...updatedRow };
    } else {
      this.examRows.push(updatedRow);
    }
    this.examRequirementsForm.patchValue({
      strExamCd: updatedRow.strExamCd || updatedRow.strExamCd || updatedRow.examCode || '',
      strExamName: updatedRow.strExamName || updatedRow.examName || '',
      strPassCd: updatedRow.strPassCd || updatedRow.passScore || '',
      strTestType: updatedRow.strTestType || updatedRow.testType || '',
      dtEffStartDate: updatedRow.dtEffStartDate || updatedRow.effectiveStartDate || '',
      dtEffEndDate: updatedRow.dtEffEndDate || updatedRow.effectiveEndDate || '',
      strStatus: updatedRow.strStatus || ''
    });
    this.examRequirementsForm.markAsDirty();

  }
  onLicenseDurationRowChanged(updatedRow: any) {
    const idx = this.licenseRows.findIndex(r => r.strLicenseType === updatedRow.strLicenseType);
    if (idx > -1) {
      this.licenseRows[idx] = { ...updatedRow };
    } else {
      this.licenseRows.push(updatedRow);
    }
    this.licenseDurationForm.patchValue({
      strLicenseType: updatedRow.strLicenseType,
      strCredType: updatedRow.strCredType,
      intLicDuration: updatedRow.intLicDuration,
      strExpDateRule: updatedRow.strExpDateRule
    });
  }
  onQueueManagementRowChanged(updatedRow: any) {
    // Mutate the row object in place to preserve input focus
    const idx = this.queueRows.findIndex(r => r.strRuleName === updatedRow.strRuleName);
    if (idx > -1) {
      Object.assign(this.queueRows[idx], updatedRow);
    }
    this.queueManagementForm.patchValue(updatedRow);
    this.queueManagementApiPayload = updatedRow;
    // Set editRowKey for save icon enablement
    this.editRowKey = updatedRow.applicationNumber || updatedRow.intBusinessRuleId;
  }
  onRegistrationRowChanged(updatedRow: any) {
    // Only update the intValue in-place to avoid grid refresh and focus loss
    const idx = this.registrationRows.findIndex(r => r.strRuleName === updatedRow.strRuleName);
    if (idx > -1) {
      this.registrationRows[idx].intValue = updatedRow.intValue !== undefined ? updatedRow.intValue : updatedRow.value;
    }
    // Only set editRowKey for save button
    this.editRowKey = updatedRow.applicationNumber || updatedRow.intBusinessRuleId;
  }
  onSecurityRowChanged(updatedRow: any) {
    // Mutate the row object in place to preserve input focus
    const idx = this.securityRows.findIndex(r => r.strRuleName === updatedRow.strRuleName);
    if (idx > -1) {
      Object.assign(this.securityRows[idx], updatedRow);
    }
    this.securityForm.patchValue(updatedRow);
    this.securityApiPayload = updatedRow;
    // Set editRowKey for save icon enablement
    this.editRowKey = updatedRow.applicationNumber || updatedRow.intBusinessRuleId;
  }

  onDocumentRowChanged(updatedRow: any) {
    const idx = this.documentRows.findIndex(r => r.strRuleName === updatedRow.strRuleName);
    if (idx > -1) {
      this.documentRows[idx].intValue = updatedRow.Value || updatedRow.intValue;
    }
    this.editRowKey = updatedRow.strRuleName;
  }

  onLicensingRowChanged(updatedRow: any) {
    const idx = this.licensingRows.findIndex(r => r.strRuleName === updatedRow.strRuleName);
    if (idx > -1) {
      this.licensingRows[idx].intValue = updatedRow.Value || updatedRow.intValue;
    }
    this.editRowKey = updatedRow.strRuleName;
  }



  onEditFeesUpdate() {
    // Save logic for application fees
    if (this.applicationFeesForm.valid) {
      // Add save logic here (e.g., update row, call API)
      this.showEditFeesModal = false;
      this.applicationFeesForm.markAsPristine();
    }
  }
  onEditFeesReset() {
    this.applicationFeesForm.reset({
      feeScheduleName: '',
      feeComponent: '',
      feeAmount: '',
      dtEffStartDate: '',
      dtEffEndDate: ''
    });
    this.showEditFeesModal = false;
  }
  onEditExamUpdate() {
    if (this.modalExamData) {
      // Patch the main form and update the table row
      this.examRequirementsForm.patchValue(this.modalExamData);
      const idx = this.examRows.findIndex(r => r.strExamCd === this.selectedExam.strExamCd);
      if (idx > -1) {
        this.examRows[idx] = { ...this.examRows[idx], ...this.modalExamData };
      }
      this.showEditExamModal = false;
      this.examRequirementsForm.markAsPristine();

      // Build payload with metadata and edited fields
      const payload = {
        ...this.selectedExam,
        ...this.modalExamData,
        objCategoryData: { ...this.modalExamData }
      };

      this.selectedExam = null;
    }
  }
  onEditFees(row: any) {
    this.applicationFeesForm.patchValue(row);
    this.showEditFeesModal = true;
  }


  openEditExamModal(row: any) {
    this.examExists = false;
    this.modalExamNameExists = false;
    this.selectedExam = { ...row };
    this.selectedExam.categoryData.dtEffEndDate = row.categoryData.dtEffEndDate || '';
    this.modalExamData = {
      strExamCd: row.strExamCd || row.examCode || '',
      strExamName: row.strExamName || row.examName || '',
      strPassCd: row.strPassCd || row.passScore || '',
      dtEffStartDate: this.formatDate(row.dtEffStartDate || row.effectiveStartDate || ''),
      dtEffEndDate: this.formatDate(row.dtEffEndDate || row.effectiveEndDate || '')
    };
    this.effEndDateToolTip = row.dtEffEndDate ? toastMessage.G0037 : toastMessage.G0036;
    this.showEditExamModal = true;
    // Reset the destroy$ subject so subscription can be re-established
    this.dtEffEndDateDestroy$ = new Subject<void>();
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'md',
      windowClass: 'systemconfig-modal'
    };
    this.customModal = this.ngbService.open(this.editExamModal, options);
    this.dtEffEndDateDestroy$ = new Subject<void>();
  }

  // OLD LOGIC - Commented out as we now always show Update Exam Status modal
  // checkDtEffEndDate(row: any) {
  //   const newEndDate = this.modalExamData.dtEffEndDate;
  //   const previousValue = row.dtEffEndDate || '';

  //   const blIsActive = newEndDate ? false : true;

  //   if (newEndDate !== previousValue) {
  //     if (blIsActive === false && newEndDate !== "") {
  //       // Deactivate: Only show modal if current date < Effective End Date
  //       const currentDate = new Date();
  //       currentDate.setHours(0, 0, 0, 0); // Reset time for date-only comparison
  //       const endDate = this.parseDateString(newEndDate);
  //       
  //       if (endDate && currentDate < endDate) {
  //         this.openExamStatusModal(false, row);
  //       } else {
  //         // Date condition not met, save directly without showing modal
  //         const payload = {
  //           ...row,
  //           ...this.modalExamData,
  //           objCategoryData: { ...this.modalExamData }
  //         };
  //         const id = this.getUserId();
  //         payload.objCategoryData.strUpdatedBy = id;
  //         payload.objCategoryData.dtUpdatedDate = new Date();
  //         payload.objCategoryData.blIsActivated = false;
  //         payload.strUpdatedBy = id;
  //         payload.strLastModifiedBy = id;
  //         this.uploadBusinessRule(payload);
  //       }
  //     } else if (newEndDate == "") {
  //       // Activate: Only show modal if current date >= Effective Start Date
  //       const currentDate = new Date();
  //       currentDate.setHours(0, 0, 0, 0); // Reset time for date-only comparison
  //       const startDate = this.parseDateString(this.modalExamData.dtEffStartDate);
  //       
  //       if (startDate && currentDate >= startDate) {
  //         this.openExamStatusModal(true, row);
  //       } else {
  //         // Date condition not met, save directly without showing modal
  //         const payload = {
  //           ...row,
  //           ...this.modalExamData,
  //           objCategoryData: { ...this.modalExamData }
  //         };
  //         const id = this.getUserId();
  //         payload.objCategoryData.strUpdatedBy = id;
  //         payload.objCategoryData.dtUpdatedDate = new Date();
  //         payload.objCategoryData.blIsActivated = true;
  //         payload.strUpdatedBy = id;
  //         payload.strLastModifiedBy = id;
  //         this.uploadBusinessRule(payload);
  //       }
  //     }
  //   } else {
  //     const payload = {
  //       ...row,
  //       ...this.modalExamData,
  //       objCategoryData: { ...this.modalExamData }
  //     };
  //     const username = this.getUsername();
  //     const id = this.getUserId();
  //     payload.objCategoryData.strUpdatedBy = id;
  //     payload.objCategoryData.dtUpdatedDate = new Date();
  //     payload.objCategoryData.blIsActivated = blIsActive;
  //     payload.strUpdatedBy = id;
  //     payload.strLastModifiedBy = id;
  //     this.uploadBusinessRule(payload);
  //   }
  // }


  formValid(form: NgForm): boolean {
    if (!form) return false;
    const hasExamCode = this.modalExamData.strExamCd && this.modalExamData.strExamCd.trim() !== '';
    const hasExamName = this.modalExamData.strExamName && this.modalExamData.strExamName.trim() !== '';
    const hasPassScore = this.modalExamData.strPassCd && this.modalExamData.strPassCd.trim() !== '';
    const hasStartDate = this.modalExamData.dtEffStartDate && this.modalExamData.dtEffStartDate.trim() !== '';
    const noExamExists = !this.examExists;
    const noExamNameExists = !this.modalExamNameExists || this.modalExamData.strExamName === this.selectedExam?.strExamName;
    const noValidationErrors = !this.examReqStartDateError && !this.examReqEndDateError;
    const hasChanges = (Object.keys(this.modalExamData).some(key => this.modalExamData[key] !== this.selectedExam.categoryData[key]));
    return form.valid && hasChanges && hasExamCode && hasExamName && hasPassScore && hasStartDate && noExamExists && noExamNameExists && noValidationErrors && form.dirty;
  }
  saveExamBusinessRule() {
    // Always show Update Exam Status modal
    this.openExamStatusModal(this.selectedExam);
  }
  cancelEditExam() {
    this.selectedExam = null;
    this.examRequirementsForm.reset();
    this.examRequirementsForm.markAsPristine();
    this.examRequirementsForm.markAsUntouched();
    if (this.customModal) {
      this.customModal.close();
    }
  }

  clearDateInput(){
    // Clear the native date input elements
    if (this.startDateTextInput?.nativeElement) {
      this.startDateTextInput.nativeElement.value = '';
    }
    if (this.endDateTextInput?.nativeElement) {
      this.endDateTextInput.nativeElement.value = '';
    }
    if (this.startHiddenDateInput?.nativeElement) {
      this.startHiddenDateInput.nativeElement.value = '';
    }
    if (this.endHiddenDateInput?.nativeElement) {
      this.endHiddenDateInput.nativeElement.value = '';
    }
  }

  onReset(){
    this.examExists = false;
    this.modalExamNameExists = false;
    this.examRequirementsForm.reset();
    
    this.clearDateInput();
  }


  addBusinessRule() {
    const form = this.getDirtyAndValidForm();
    if (!form) {
      console.warn('No dirty and valid form found');
      return;
    }
    // Use the correct interface for payload
    let payload: ApplicationRule | ApplicationFee | ExamRequirement | LicenseDuration | GenericRule | BackgroundCheck = this.buildBusinessRulePayload(form.value);
    const username = this.getUsername();
    const id = this.getUserId();
    if (payload && typeof payload === 'object') {
      (payload as any).strUpdatedBy = id;
      (payload as any).strLastModifiedBy = id;
      if((payload as any).strCategory === 'Exam Requirements'){
        // Determine status based on effective dates
        const startDate = (payload as any).objCategoryData.dtEffStartDate;
        const endDate = (payload as any).objCategoryData.dtEffEndDate;
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Reset time to midnight for date-only comparison
        
        let isActive = false;
        if (startDate) {
          const effectiveStartDate = new Date(startDate);
          effectiveStartDate.setHours(0, 0, 0, 0);
          
          if (endDate) {
            const effectiveEndDate = new Date(endDate);
            effectiveEndDate.setHours(0, 0, 0, 0);
            
            // Active if: startDate <= currentDate <= endDate (exam is active ON the end date)
            isActive = effectiveStartDate <= currentDate && currentDate <= effectiveEndDate;
          } else {
            // If no end date, active if startDate <= currentDate
            isActive = effectiveStartDate <= currentDate;
          }
        }
        
        (payload as any).objCategoryData.blIsActivated = isActive;
      }
    }
    this.systemConfigurationService.insertBusinessRule(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.data.success) {
            this.alertService.success(this.toastMessage['T0020'] || errorMessages.addedSuccess);
            this.fetchBusinessRulesData();
            this.formReset();
            this.clearDateInput();
          } else {
            this.alertService.error('Error while adding');
          }
        },
        error: err => {
          console.error('API call failed', err);
          this.alertService.error(errorMessages.saveBusiness);
        }
      });
  }

  private getDirtyAndValidForm(): FormGroup | null {
    if (this.applicationForm?.dirty && this.applicationForm?.valid) {
      return this.applicationForm;
    }
    if (this.applicationFeesForm?.dirty && this.applicationFeesForm?.valid) {
      return this.applicationFeesForm;
    }
    if (this.examRequirementsForm?.dirty && this.examRequirementsForm?.valid) {
      return this.examRequirementsForm;
    }
    if (this.caseForm?.dirty && this.caseForm?.valid) {
      return this.caseForm;
    }
    if (this.documentForm?.dirty && this.documentForm?.valid) {
      return this.documentForm;
    }
    if (this.licensingForm?.dirty && this.licensingForm?.valid) {
      return this.licensingForm;
    }
    return null;
  }
  formReset() {
    this.examRequirementsForm.reset();
    this.applicationFeesForm.reset();
    this.applicationForm.reset();
    this.caseForm.reset();
    this.documentForm.reset();
    this.licensingForm.reset();
  }
  private buildBusinessRulePayload(values: any): any {
    const objCategoryData: any = this.extractObjCategoryData(values);
    const username = this.getUsername();
    const id = this.getUserId();
    
    // Determine category based on which form is dirty
    let category = 'Exam Requirements'; // default
    if (this.applicationForm?.dirty && this.applicationForm?.valid) {
      category = 'Application';
    } else if (this.applicationFeesForm?.dirty && this.applicationFeesForm?.valid) {
      category = 'Application Fees';
    } else if (this.examRequirementsForm?.dirty && this.examRequirementsForm?.valid) {
      category = 'Exam Requirements';
    } else if (this.caseForm?.dirty && this.caseForm?.valid) {
      category = 'Case';
    } else if (this.documentForm?.dirty && this.documentForm?.valid) {
      category = 'Documents';
    } else if (this.licensingForm?.dirty && this.licensingForm?.valid) {
      category = 'Licensing';
    }
    
    const payload: any = {
      strCategory: values.strCategory || values.category || category,
      objCategoryData,
      dtCreatedDate: values.dtCreatedDate || new Date(),
      dtModifiedDate: values.dtModifiedDate || new Date(),
      strLastModifiedBy: values.strLastModifiedBy || id,
      strCreatedBy: values.strCreatedBy || id,
      strUpdatedBy: username || id,
      dtUpdatedDate: values.dtUpdatedDate || new Date(),
      blIsActive: values.blIsActive !== undefined ? values.blIsActive : true
    };
    if (values.intBusinessRuleId) payload.intBusinessRuleId = values.intBusinessRuleId;
    return payload;
  }

  private extractObjCategoryData(values: any): any {
    const objCategoryData: any = values.objCategoryData ? { ...values.objCategoryData } : {};
    const fields = businessFields[0];
    fields.forEach(f => { 
      if (values[f] !== undefined && values[f] !== null && values[f] !== '') {
        objCategoryData[f] = values[f]; 
      }
    });
    return objCategoryData;
  }

  private getUsername(): string {
    const roleId = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user') || '{}') : null;
    if (roleId) {
      const first = roleId.firstname || '';
      const middle = roleId.middlename || '';
      const last = roleId.lastname || '';
      let username = [first, middle, last].filter(Boolean).join(' ').trim();
      if (!username) username = roleId.username || '';
      return username;
    }
    return '';
  }

  private getUserId(): string {
    const roleId = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user') || '{}') : null;
    return roleId && roleId.id ? `${roleId.id}` : '';
  }

  saveBusinessRule(row: any) {
    if (!row || !row.valueChanged) return;
    const intBusinessRuleId = row.intBusinessRuleId;
    const baseObjCategoryData = row.objCategoryData || row.category || row.categoryData || {};
    const objCategoryData = { ...baseObjCategoryData };

    if (row.Value !== undefined) {
      objCategoryData.intValue = row.Value;
    }

    Object.keys(objCategoryData).forEach(key => {
      if (row[key] !== undefined) {
        objCategoryData[key] = row[key];
      }
    });

    businessFields[1].forEach(key => {
      if (row[key] !== undefined) {
        objCategoryData[key] = row[key];
      }
    });
    const username = this.getUsername();
    const id = this.getUserId();
    const payload: any = {
      intBusinessRuleId: intBusinessRuleId,
      strCategory: row.strCategory,
      objCategoryData: objCategoryData,
      dtCreatedDate: row.dtCreatedDate,
      dtModifiedDate: row.dtModifiedDate,
      strLastModifiedBy: id,
      strCreatedBy: row.strCreatedBy,
      strUpdatedBy: id,
      dtUpdatedDate: row.dtUpdatedDate,
      blIsActive: row.blIsActive
    };
    payload.objCategoryData.strUpdatedBy = id;
    payload.objCategoryData.dtUpdatedDate = new Date();
    this.uploadBusinessRule(payload, false, row);

    // Keep row state and original-value map in sync immediately to avoid stale Save enablement.
    const normalizedValue = row.Value !== undefined && row.Value !== null
      ? row.Value
      : row.intValue !== undefined && row.intValue !== null
        ? row.intValue
        : row.value;

    if (normalizedValue !== undefined) {
      row.Value = normalizedValue;
      row.intValue = normalizedValue === '' ? null : Number(normalizedValue);
      row.value = normalizedValue;
      row.originalValue = String(normalizedValue);
    }
    row.valueChanged = false;

    const originalEntry = {
      intValue: row.intValue,
      Value: row.Value,
      value: row.value,
      strUnit: row.strUnit,
      strAppliesTo: row.strAppliesTo
    };

    const candidateKeys = [row.strRuleName, row.ruleName, row.applicationNumber, row.intBusinessRuleId]
      .filter((k: any) => k !== undefined && k !== null && k !== '');
    candidateKeys.forEach((k: any) => {
      this.originalRowValues[k] = originalEntry;
    });
  }
  onDateIconSelect(dateValue: string, dateTextInput: HTMLInputElement) {
    if (dateValue) {
      // Format date as MM/DD/YYYY
      const d = new Date(dateValue);
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const yyyy = d.getFullYear();
      const formatted = `${mm}/${dd}/${yyyy}`;
      // Set value on the Angular form control
      let ctrlName = dateTextInput.getAttribute('formControlName');
      if (!ctrlName && dateTextInput.placeholder && dateTextInput.placeholder.toLowerCase().includes('end')) {
        ctrlName = 'dtEffEndDate';
      } else if (!ctrlName && dateTextInput.placeholder && dateTextInput.placeholder.toLowerCase().includes('start')) {
        ctrlName = 'dtEffStartDate';
      }
      // Always prefer modal form if open
      let ctrl = this.examRequirementsForm?.get(ctrlName || '');
      if (ctrl) {
        ctrl.setValue(formatted);
        ctrl.markAsTouched();
        ctrl.markAsPristine();
        ctrl.updateValueAndValidity();
      } else if (this.examRequirementsForm?.get(ctrlName || '')) {
        let ctrl2 = this.examRequirementsForm.get(ctrlName || '');
        ctrl2?.setValue(formatted);
        ctrl2?.markAsTouched();
        ctrl2?.markAsPristine();
        ctrl2?.updateValueAndValidity();
      }
      // Always update the native input value after Angular form update
      setTimeout(() => {
        dateTextInput.value = formatted;
        if (this.cd && typeof this.cd.detectChanges === 'function') {
          this.cd.detectChanges();
        }
      }, 0);
      // Trigger input event for any listeners
      const event = new Event('input', { bubbles: true });
      dateTextInput.dispatchEvent(event);
    }else{
      // If dateValue is empty, clear the form control and input  value
      let ctrlName = dateTextInput.getAttribute('formControlName');
      if (!ctrlName && dateTextInput.placeholder && dateTextInput.placeholder.toLowerCase().includes('end')) {
        ctrlName = 'dtEffEndDate';
      } else if (!ctrlName && dateTextInput.placeholder && dateTextInput.placeholder.toLowerCase().includes('start')) {
        ctrlName = 'dtEffStartDate';
      }
      // Always prefer modal form if open
      let ctrl = this.examRequirementsForm?.get(ctrlName || '');
      if (ctrl) {
        ctrl.setValue('');
        ctrl.markAsTouched();
        ctrl.markAsPristine();
        ctrl.updateValueAndValidity();
      } else if (this.examRequirementsForm?.get(ctrlName || '')) {
        let ctrl2 = this.examRequirementsForm.get(ctrlName || '');
        ctrl2?.setValue('');
        ctrl2?.markAsTouched();
        ctrl2?.markAsPristine();
        ctrl2?.updateValueAndValidity();
      }
      // Always update the native input value after Angular form update
      setTimeout(() => {
        dateTextInput.value = '';
        if (this.cd && typeof this.cd.detectChanges === 'function') {
          this.cd.detectChanges();
        }
      }, 0);
      // Trigger input event for any listeners
      const event = new Event('input', { bubbles: true });
      dateTextInput.dispatchEvent(event);
    }
  }
  uploadBusinessRule(payload, modal?: boolean, row?: any) {
    this.systemConfigurationService.updateBusinessRule(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.data.success) {
            if (this.customModal && typeof this.customModal.close === 'function') {
              this.customModal.close();
            }
            if(modal){
              this.alertService.success(errorMessages.examUpdate);
            }else{
              this.alertService.success(this.toastMessage['T0020'] || errorMessages.savedSuccess);
            }
            if (row) {
              row.apiError = null;
            }
            this.fetchBusinessRulesData();
            this.editRowKey = null;
            if (this.applicationForm) this.applicationForm.markAsPristine();
          } else {
           let errorMsg = res.data?.errors?.[0] || res.errors?.[0] || '';
            if (errorMsg && errorMsg.includes(':')) {
              errorMsg = errorMsg.split(':').slice(1).join(':').trim();
            }
            if (row && errorMsg) {
              row.apiError = errorMsg;
            }
          }
        },
        error: () => {
          // Handle error if needed
        }
      });
    this.selectedExam = null;
    this.examRequirementsForm.reset();
    this.examRequirementsForm.markAsPristine();
    this.examRequirementsForm.markAsUntouched();
  }
  
  // New method for Update Exam Status with T0039 toast
  uploadBusinessRuleWithStatusToast(payload, row?: any) {
    this.systemConfigurationService.updateBusinessRule(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.data.success) {
            if (this.customModal && typeof this.customModal.close === 'function') {
              this.customModal.close();
            }
            // Show T0039 toast message for status change
            this.alertService.success(this.toastMessage['T0039'] || 'Exam status updated successfully.');
            if (row) {
              row.apiError = null;
            }
            this.fetchBusinessRulesData();
            this.editRowKey = null;
            if (this.applicationForm) this.applicationForm.markAsPristine();
          } else {
           let errorMsg = res.data?.errors?.[0] || res.errors?.[0] || '';
            if (errorMsg && errorMsg.includes(':')) {
              errorMsg = errorMsg.split(':').slice(1).join(':').trim();
            }
            if (row && errorMsg) {
              row.apiError = errorMsg;
            }
          }
        },
        error: () => {
          // Handle error if needed
        }
      });
    this.selectedExam = null;
    this.examRequirementsForm.reset();
    this.examRequirementsForm.markAsPristine();
    this.examRequirementsForm.markAsUntouched();
  }
  closeModal() {
    this.dtEffEndDateDestroy$.next();
    this.selectedExam = null;
    this.examRequirementsForm.reset();
    this.examRequirementsForm.markAsPristine();
    this.examRequirementsForm.markAsUntouched();
    this.showEditExamModal = false;
    // Unsubscribe from dtEffEndDate.valueChanges when modal closes
    if (this.customModal && typeof this.customModal.close === 'function') {
      this.customModal.close();
    }
  }
 onEditExamReset(row: any) {
  this.examExists = false;
  this.modalExamNameExists = false;
    this.selectedExam = { ...row };
    // Reset the form before patching to clear any previous values
     this.modalExamData = {
      strExamCd: row.strExamCd || row.examCode || '',
      strExamName: row.strExamName || row.examName || '',
      strPassCd: row.strPassCd || row.passScore || '',
      dtEffStartDate: this.formatDate(row.dtEffStartDate || row.effectiveStartDate || ''),
      dtEffEndDate: this.formatDate(row.dtEffEndDate || row.effectiveEndDate || '')
    };
    this.showEditExamModal = false;
  }
  onAddFeesReset() {
    this.applicationFeesForm.reset({
      feeScheduleName: '',
      feeComponent: '',
      feeAmount: '',
      dtEffStartDate: '',
      dtEffEndDate: ''
    });
  }
  onResetRow(section: string, row?: any): void {
    if (!row) return;

    // Resolve the row key used to look up the saved original value.
    const rowKey = row.strRuleName || row.ruleName
      || row.strFeeSchedNm || row.strAppPath || row.strExamCd || row.strLicenseType
      || row.intBusinessRuleId;

    const originalEntry = this.originalRowValues[rowKey] || {};

    // Pick the best reset value: prefer Value/intValue from the saved entry,
    // fall back to the originalValue that editdatagrid stamped when editing started.
    const resetValue: any =
      originalEntry.Value !== undefined ? originalEntry.Value
      : originalEntry.intValue !== undefined ? originalEntry.intValue
      : row.originalValue !== undefined ? row.originalValue
      : row.Value;

    // -- Directly mutate the template row (the live reference the grid renders). --
    // This is the same object as configProp.data[i]; mutating it here means
    // the grid sees the change immediately on the next detectChanges() call.
    row.Value = resetValue;
    row.intValue = (resetValue !== '' && resetValue !== null && resetValue !== undefined)
      ? Number(resetValue) : null;
    row.value = resetValue;
    row.originalValue = String(resetValue ?? '');
    row.valueChanged = false;
    row.valueError = resetValue === undefined || resetValue === null || resetValue === '';
    row.apiError = null;

    // -- Also sync the backing rowsArr so future lookups are consistent. --
    const { rowsArr } = this.getGridRowConfig(section);
    const norm = (v: any) => (v !== undefined && v !== null ? String(v) : '');
    const idx = rowsArr.findIndex(r =>
      norm(r.strRuleName || r.intBusinessRuleId) === norm(rowKey)
      || norm(r.strFeeSchedNm || r.strAppPath || r.strExamCd || r.strLicenseType) === norm(rowKey)
    );
    if (idx > -1) {
      Object.assign(rowsArr[idx], {
        Value: resetValue,
        intValue: row.intValue,
        value: resetValue,
        originalValue: row.originalValue,
        valueChanged: false,
        valueError: row.valueError,
        apiError: null
      });
    }

    this.editRowKey = null;
    this.cd.detectChanges();
  }
  private getGridRowConfig(section: string): { rowsArr: any[], key: string, valueProp: string, configProp: string } {
    switch (section) {
      case 'Application':
        return { rowsArr: this.applicationRows, key: 'strRuleName', valueProp: 'intValue', configProp: 'dataGridConfigApplication' };
      case 'ApplicationFees':
        return { rowsArr: this.feeRows, key: 'strFeeSchedNm', valueProp: 'strFeeAmt', configProp: 'dataGridConfigFees' };
      case 'Background':
        return { rowsArr: this.backgroundRows, key: 'strAppPath', valueProp: 'intBgCheckReq', configProp: 'dataGridConfigBackground' };
      case 'ExamRequirements':
        return { rowsArr: this.examRows, key: 'strExamCd', valueProp: 'strPassCd', configProp: 'dataGridConfigEmployee' };
      case 'LicenseDuration':
        return { rowsArr: this.licenseRows, key: 'strLicenseType', valueProp: 'intLicDuration', configProp: 'dataGridConfigLicense' };
      case 'QueueManagement':
        return { rowsArr: this.queueRows, key: 'strRuleName', valueProp: 'intValue', configProp: 'dataGridConfigQueues' };
      case 'Registration':
        return { rowsArr: this.registrationRows, key: 'strRuleName', valueProp: 'intValue', configProp: 'dataGridConfigRegistration' };
      case 'Security':
        return { rowsArr: this.securityRows, key: 'strRuleName', valueProp: 'intValue', configProp: 'dataGridConfigSecurity' };
      case 'Case':
        return { rowsArr: this.caseRows, key: 'strRuleName', valueProp: 'intValue', configProp: 'dataGridConfigCase' };
      case 'Documents':
        return { rowsArr: this.documentRows, key: 'strRuleName', valueProp: 'intValue', configProp: 'dataGridConfigDocument' };
      case 'Licensing':
        return { rowsArr: this.licensingRows, key: 'strRuleName', valueProp: 'intValue', configProp: 'dataGridConfigLicensing' };
      default:
        return { rowsArr: [], key: '', valueProp: '', configProp: '' };
    }
  }

  private resetGridRow(section: string, row: any, columnKey?: string): void {
    const { rowsArr, key, valueProp, configProp } = this.getGridRowConfig(section);
    if (!(rowsArr.length && key)) {
      this.editRowKey = null;
      return;
    }

    const rowKey = this.getRowKey(section, row, key);
    const ruleName = row.objCategoryData.strRuleName || row.ruleName;

    // Find the row by key only — do NOT gate on valueChanged here.
    // isMatchingRow gating on valueChanged caused Reset to silently fail
    // when the user had already saved (valueChanged == false).
    const idx = rowsArr.findIndex(r => {
      let rKey = this.getRowKeyValue(r, key);
      const rRuleName = this.getRuleNameValue(r);
      if (section === 'Registration' && (!rKey || rKey === '')) {
        rKey = rRuleName;
      }
      const norm = (v: any) => v !== undefined && v !== null ? String(v) : '';
      return norm(rKey) === norm(rowKey) || norm(rRuleName) === norm(ruleName);
    });
    if (idx > -1) {
      this.resetRowValue(rowsArr, idx, rowKey, ruleName, columnKey, valueProp);
      if (this[configProp] && typeof this[configProp].updateConfig === 'function') {
        const updatedRow = { ...rowsArr[idx] };
        const newData = this[configProp].data.map((r: any, i: number) => i === idx ? updatedRow : r);
        this[configProp] = this[configProp].updateConfig({ data: newData });
      }
    }
    this.editRowKey = null;
  }

  private getRowKey(section: string, row: any, key: string): any {
    let rowKey = row[key];
    if (!rowKey || rowKey === '') {
      if (row.objCategoryData.strRuleName) {
        rowKey = row.objCategoryData.strRuleName;
      } else if (row.strFeeSchedNm) {
        rowKey = row.strFeeSchedNm;
      } else if (row.strAppPath) {
        rowKey = row.strAppPath;
      } else if (row.strExamCd) {
        rowKey = row.strExamCd;
      } else if (row.strLicenseType) {
        rowKey = row.strLicenseType;
      }
    }
    let ruleName = (row.objCategoryData && row.objCategoryData.strRuleName) || row.strRuleName || row.ruleName;
    if (section === 'Registration' && (!rowKey || rowKey === '')) {
      rowKey = ruleName;
    }
    return rowKey;
  }
  isExamexists() {
    this.examExists = this.examRows.some(r => r.strExamCd.toLowerCase() === this.examRequirementsForm.controls.strExamCd.value.toLowerCase());
  }
  isModalExamExists() {
    if(this.modalExamData.strExamCd === this.selectedExam?.strExamCd){
      this.examExists = false;
      return;
    }
    this.examExists = this.examRows.some(
      r => r.strExamCd && r.strExamCd.toLowerCase() === (this.modalExamData.strExamCd || '').toLowerCase()
    );
  }
  isExamNameExists() {
    this.modalExamNameExists = this.examRows.some(
        r => r.strExamName && r.strExamName.toLowerCase() === (this.examRequirementsForm.controls.strExamName.value || '').toLowerCase()
      );
  }
  isModalExamNameExists() {
      if(this.modalExamData.strExamName === this.selectedExam?.strExamName){
      this.modalExamNameExists = false;
      return;
    }
    this.modalExamNameExists = this.examRows.some(
        r => r.strExamName && r.strExamName.toLowerCase() === (this.modalExamData.strExamName || '').toLowerCase()
      );
  }
  private getRowKeyValue(r: any, key: string): any {
    if (r[key]) return r[key];
    if (r.intBusinessRuleId) return r.intBusinessRuleId;
    if (r.objCategoryData?.strRuleName) return r.objCategoryData.strRuleName;
    if (r.strFeeSchedNm) return r.strFeeSchedNm;
    if (r.strAppPath) return r.strAppPath;
    if (r.strExamCd) return r.strExamCd;
    if (r.strLicenseType) return r.strLicenseType;
    return '';
  }

  private getRuleNameValue(r: any): any {
    return (r.objCategoryData && r.objCategoryData.strRuleName) || r.strRuleName || r.ruleName;
  }

  private hasValueChanged(r: any, originalRow: any, columnKey?: string, valueProp?: string): boolean {
    if (columnKey && originalRow[columnKey] !== undefined) {
      return r[columnKey] !== originalRow[columnKey];
    }
    if (valueProp && originalRow[valueProp] !== undefined) {
      return r[valueProp] !== originalRow[valueProp];
    }
    return true;
  }

  private isMatchingRow(
    section: string,
    r: any,
    key: string,
    rowKey: any,
    ruleName: any,
    columnKey?: string,
    valueProp?: string
  ): boolean {
    let rKey = this.getRowKeyValue(r, key);
    const rRuleName = this.getRuleNameValue(r);
    if (section === 'Registration' && (!rKey || rKey === '')) {
      rKey = rRuleName;
    }
    const norm = (v: any) => v !== undefined && v !== null ? String(v) : '';
    const matchKey = norm(rKey) === norm(rowKey);
    const matchRuleName = norm(rRuleName) === norm(ruleName);
    const originalRow = this.originalRowValues[rowKey] || this.originalRowValues[ruleName] || {};
    const valueChanged = this.hasValueChanged(r, originalRow, columnKey, valueProp);
    return (matchKey || matchRuleName) && valueChanged;
  }

  private resetRowValue(
    rowsArr: any[],
    idx: number,
    rowKey: any,
    ruleName: any,
    columnKey?: string,
    valueProp?: string
  ): void {
    const originalRow = this.originalRowValues[rowKey] || this.originalRowValues[ruleName] || {};
    if (columnKey && originalRow[columnKey] !== undefined) {
      rowsArr[idx][columnKey] = originalRow[columnKey];
    } else if (valueProp && originalRow[valueProp] !== undefined) {
      rowsArr[idx][valueProp] = originalRow[valueProp];

      // Keep editdatagrid value fields aligned so Save stays disabled after reset.
      if (valueProp === 'intValue') {
        const resetValue = originalRow.Value !== undefined ? originalRow.Value : originalRow[valueProp];
        rowsArr[idx].Value = resetValue;
        rowsArr[idx].value = resetValue;
        rowsArr[idx].originalValue = String(resetValue ?? '');
        rowsArr[idx].valueChanged = false;
        rowsArr[idx].valueError = resetValue === undefined || resetValue === null || resetValue === '';
      }
    }

    // Clear any stale inline errors after reset.
    rowsArr[idx].apiError = null;
  }

  // --- Modal logic for Update Exam Status ---
  openExamStatusModal(row?: any) {
    this.dtEffEndDateDestroy$.next();
    if (this.customModal && typeof this.customModal.close === 'function') {
      this.customModal.close();
    }
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'md',
      windowClass: 'update-exam-status-modal'
    };
    const statusModal = this.ngbService.open(ModalComponent, options);
    
    // Build dynamic modal content with dates
    const effectiveStartDate = this.modalExamData?.dtEffStartDate || '';
    const effectiveEndDate = this.modalExamData?.dtEffEndDate || '';
    let dynamicModalContent: string;
    
    // Update Exam Status modal
    if (effectiveEndDate) {
      dynamicModalContent = `<p>This exam will be available in Nevada Praxis Testing for new applications from ${effectiveStartDate} to ${effectiveEndDate}.</p>`;
    } else {
      dynamicModalContent = `<p>This exam will be available in Nevada Praxis Testing for new applications effective ${effectiveStartDate}.</p>`;
    }
    
    const modalConfig: ModalConfig = {
      buttons: [
        { text: modalButtonTitles.cancel, code: 'N', btnOutline: true },
        { text: modalButtonTitles.proceed, code: 'Y' }
      ],
      heading: 'Update Exam Status',
      modalContent: dynamicModalContent,
      hasTemplate: false
    };
    statusModal.componentInstance.modalConfig = modalConfig;
    statusModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
      if (response && response.confirmed === true) {
        // Calculate status based on effective dates
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const startDate = this.parseDateString(this.modalExamData.dtEffStartDate);
        const endDate = effectiveEndDate ? this.parseDateString(this.modalExamData.dtEffEndDate) : null;
        
        let newStatus: boolean;
        // Status logic: INACTIVE if: e.start.d > current_date OR current_date > e.end.d
        // ACTIVE otherwise (including when e.end.d = current_date)
        if (startDate && startDate > currentDate) {
          newStatus = false; // Inactive: start date is in future
        } else if (endDate && currentDate > endDate) {
          newStatus = false; // Inactive: current date is AFTER end date
        } else {
          newStatus = true; // Active: all conditions met (includes when end date = current date)
        }
        
        
        this.isExamActive = newStatus;
        if (row) this.selectedExam.category.blIsActivated = newStatus;
        
        if (this.modalExamData) {
          // Patch the main form and update the table row
          this.examRequirementsForm.patchValue(this.modalExamData);
          const idx = this.examRows.findIndex(r => r.strExamCd === this.selectedExam.strExamCd);
          if (idx > -1) {
            this.examRows[idx] = { ...this.examRows[idx], ...this.modalExamData };
          }
          this.showEditExamModal = false;
          this.examRequirementsForm.markAsPristine();

          const payload = {
            ...this.selectedExam,
            ...this.modalExamData,
            objCategoryData: { ...this.modalExamData }
          };

          const id = this.getUserId();
          if (payload && typeof payload === 'object') {
            payload.objCategoryData.strUpdatedBy = id;
            payload.objCategoryData.dtUpdatedDate = new Date();
            payload.objCategoryData.blIsActivated = newStatus;
            payload.strUpdatedBy = id;
            payload.strLastModifiedBy = id;
          }
          
          // Show T0039 toast message for status update
          this.uploadBusinessRuleWithStatusToast(payload);
        } else {
          this.closeModal();
        }
      }
    });
  }
  get dtEffEndDate() {
    return this.examRequirementsForm.get('dtEffEndDate');
  }
   


  get dtEffStartDateError(): string | null {
    const ctrl = this.examRequirementsForm?.get('dtEffStartDate');
    const endCtrl = this.examRequirementsForm?.get('dtEffEndDate');
    if (!ctrl) return null;
    if (ctrl.touched || ctrl.dirty) {
      const startValue = ctrl.value;
      const endValue = endCtrl?.value;
      const dateRegex = /^(\d{4}-\d{2}-\d{2})|(\d{1,2}\/\d{1,2}\/\d{4})$/;
      if (!startValue) {
        // return errorMessages.selectEffStartDate;
        return this.errorMessage['M0131'] || errorMessages.selectEffStartDate;
      }
      if (!dateRegex.test(startValue)) {
        return errorMessages.invalidDate;
      }
      const startDate = new Date(startValue);
      if (isNaN(startDate.getTime())) {
        return errorMessages.invalidDate;
      }
      if (endValue) {
        if (!dateRegex.test(endValue)) {
          return null;
        }
        const endDate = new Date(endValue);
        if (isNaN(endDate.getTime())) {
          return null;
        }
        if (startDate.getTime() > endDate.getTime()) {
          return 'Start date must be before end date.';
        }
      }
      if (ctrl.invalid) {
        return errorMessages.invalidDate;
      }
    }
    return null;
  }

  get dtEffEndDateError(): string | null {
    const ctrl = this.examRequirementsForm?.get('dtEffEndDate');
    const startCtrl = this.examRequirementsForm?.get('dtEffStartDate');
    if (!ctrl) return null;
    if (ctrl.touched || ctrl.dirty) {
      const endValue = ctrl.value;
      const startValue = startCtrl?.value;
      const dateRegex = /^(\d{4}-\d{2}-\d{2})|(\d{1,2}\/\d{1,2}\/\d{4})$/;
      if (!endValue) {
        return errorMessages.selectEffEndDate;
      }
      if (!dateRegex.test(endValue)) {
        return this.errorMessage['M0202'] || errorMessages.invalidDate;
      }
      const endDate = new Date(endValue);
      if (isNaN(endDate.getTime())) {
        return this.errorMessage['M0202'] || errorMessages.invalidDate;
      }
      if (!startValue) {
        return 'Please enter the start date.';
      }
      if (!dateRegex.test(startValue)) {
        return null;
      }
      const startDate = new Date(startValue);
      if (isNaN(startDate.getTime())) {
        return null;
      }
      if (startDate.getTime() > endDate.getTime()) {
        return 'End date must be after start date.';
      }
      if (ctrl.invalid) {
        return this.errorMessage['M0202'] || errorMessages.invalidDate;
      }
    }
    return null;
  }
  get examReqStartDateError(): string | null {
    const value = this.modalExamData.dtEffStartDate;
    const endValue = this.modalExamData.dtEffEndDate;
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!value) {
      // return errorMessages.selectEffStartDate;
      return this.errorMessage['M0131'] || errorMessages.selectEffStartDate;
    }
    if (!dateRegex.test(value)) {
      return errorMessages.invalidDate;
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return errorMessages.invalidDate;
    }
    if (endValue) {
      if (!dateRegex.test(endValue)) {
        return null;
      }
      const endDate = new Date(endValue);
      if (isNaN(endDate.getTime())) {
        return null;
      }
      if (date.getTime() > endDate.getTime()) {
        return 'Start date must be before end date.';
      }
    }
    return null;
  }

  get examReqEndDateError(): string | null {
    const endValue = this.modalExamData.dtEffEndDate;
    const startValue = this.modalExamData.dtEffStartDate;
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (endValue) {
      if (!dateRegex.test(endValue)) {
        return errorMessages.invalidDate;
      }
      const endDate = new Date(endValue);
      if (isNaN(endDate.getTime())) {
        return errorMessages.invalidDate;
      }
      if (startValue) {
        if (!dateRegex.test(startValue)) {
          return null;
        }
        const startDate = new Date(startValue);
        if (isNaN(startDate.getTime())) {
          return null;
        }
        if (startDate.getTime() > endDate.getTime()) {
          return 'End date must be after start date.';
        }
      }
    }
    return null;
  }
  public setGridPagerClass() {
    this.dataGridConfigApplication && (this.dataGridConfigApplication.hidePager = (this.applicationRows.length < 5));
    this.dataGridConfigFees && (this.dataGridConfigFees.hidePager = (this.feeRows.length < 5));
    this.dataGridConfigBackground && (this.dataGridConfigBackground.hidePager = (this.backgroundRows.length < 5));
    this.dataGridConfigEmployee && (this.dataGridConfigEmployee.hidePager = (this.examRows.length < 5));
    this.dataGridConfigLicense && (this.dataGridConfigLicense.hidePager = (this.licenseRows.length < 5));
    this.dataGridConfigQueues && (this.dataGridConfigQueues.hidePager = (this.queueRows.length < 5));
    this.dataGridConfigRegistration && (this.dataGridConfigRegistration.hidePager = (this.registrationRows.length < 5));
    this.dataGridConfigSecurity && (this.dataGridConfigSecurity.hidePager = (this.securityRows.length < 5));
    this.dataGridConfigCase && (this.dataGridConfigCase.hidePager = (this.caseRows.length < 5));
    this.dataGridConfigDocument && (this.dataGridConfigDocument.hidePager = (this.documentRows.length < 5));
    this.dataGridConfigLicensing && (this.dataGridConfigLicensing.hidePager = (this.licensingRows.length < 5));
  }
  strictDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      const dateRegex = /^(\d{4}-\d{2}-\d{2})|(\d{1,2}\/\d{1,2}\/\d{4})$/;
      if (!dateRegex.test(value)) {
        return { invalidDateFormat: true };
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return { invalidDate: true };
      }
      return null;
    };
  }
  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  // Helper function to parse date string in MM/DD/YYYY format
  parseDateString(dateStr: string): Date | null {
    if (!dateStr) return null;
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;
    const month = parseInt(parts[0], 10) - 1; // Month is 0-indexed
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    const date = new Date(year, month, day);
    date.setHours(0, 0, 0, 0); // Reset time for date-only comparison
    return date;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.dtEffEndDateDestroy$.next();
    this.dtEffEndDateDestroy$.complete();
  }

}